import { render, staticRenderFns } from "./HeaderWeb.vue?vue&type=template&id=6c42835a&scoped=true"
import script from "./HeaderWeb.vue?vue&type=script&lang=js"
export * from "./HeaderWeb.vue?vue&type=script&lang=js"
import style0 from "./HeaderWeb.vue?vue&type=style&index=0&id=6c42835a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42835a",
  null
  
)

export default component.exports